var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((6),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","xl":"2","lg":"3","md":"4","sm":"6","xs":"12"}},[[_c('v-sheet',{staticClass:"pa-0",attrs:{"color":"grey lighten-4"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"card, article"}})],1)]],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }